import React, { useContext } from "react";
import { AppBar, Toolbar, Typography, Button, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { LightMode, DarkMode } from "@mui/icons-material";
import { ColorModeContext } from "../context/ColorModeContext";
import { useMediaQuery } from "@mui/material"; // Import useMediaQuery

const TopBar = () => {
  const { mode, toggleColorMode } = useContext(ColorModeContext);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm")); // Check if the screen size is small or smaller

  // Set the logo path based on the theme mode
  const logoSrc = `${process.env.PUBLIC_URL}/img/logos/minervawhite.png`;

  return (
    <AppBar position="sticky">
      <Toolbar>
        <Typography
          variant="h6"
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            color: "#FFFFFF",
          }}
          component={Link}
          to="/"
        >
          <img
            src={logoSrc}
            alt="Minerva Logo"
            style={{ width: 50, height: 35, marginRight: 10 }}
          />
          {!isMobile && "Minerva Chess Analysis"}
        </Typography>

        {/* Links to the Home, Analysis, and About pages */}
        <Button color="inherit" component={Link} to="/">
          Home
        </Button>
        <Button color="inherit" component={Link} to="/analysis">
          Analysis
        </Button>
        <Button color="inherit" component={Link} to="/about">
          About
        </Button>

        {/* Theme Toggle Icon Button */}
        <IconButton color="inherit" onClick={toggleColorMode} sx={{ ml: 2 }}>
          {mode === "light" ? <DarkMode /> : <LightMode />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
